
import { Component, Vue } from 'vue-property-decorator'

/**
 * パスワード用インプットタグ
 */
@Component
export default class InputPasswordBase extends Vue {
  /**
   * 入力時のイベント
   *
   * @param event イベント
   */
  private inputEvent(event: Event): void {
    this.$emit('input', (event.target as HTMLInputElement).value)
  }
}
